import { render, staticRenderFns } from "./agreementBasisGroupTable.vue?vue&type=template&id=716a6ed7&scoped=true&"
import script from "./agreementBasisGroupTable.vue?vue&type=script&lang=js&"
export * from "./agreementBasisGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./agreementBasisGroupTable.vue?vue&type=style&index=0&id=716a6ed7&lang=scss&scoped=true&"
import style1 from "./agreementBasisGroupTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a6ed7",
  null
  
)

export default component.exports